import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectAuthState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { zip } from 'rxjs';

@Component({
  selector: 'app-dialog-new-member',
  templateUrl: './dialog-new-member.component.html',
  styleUrls: ['./dialog-new-member.component.scss']
})
export class DialogNewMemberComponent implements OnInit {
  formMember: FormGroup;
  modificarDatos: boolean = false;
  lstEmpresas: any[] = [];
  lstRoles: any[] = [];
  getStateAuthentication;
  authentication;
  user: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogNewMemberComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private coalService: CoalService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.getStateAuthentication = this.store.select(selectAuthState);
    this.formMember = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
      nombre: new FormControl('', Validators.required),
      celular: new FormControl(''),
      idRol: new FormControl('', Validators.required),
      idEmpresas: new FormControl('', Validators.required)
    });
    if(data && data.attributes) {
      this.modificarDatos = true;
    }
  }

  ngOnInit(): void {
    this.authentication = this.getStateAuthentication.subscribe((state) => {
      this.user = state?.seguridad?.user;
      this.getInitialData();
      if (this.data && this.data.attributes) {
        this.getUserCompanies();
      }
    })
  }

  fillDataUser (companies) {
    this.formMember.controls.password.disable();
    this.formMember.controls.nombre.setValue(this.data.attributes.name);
    this.formMember.controls.idEmpresas.setValue(companies);
    this.formMember.controls.email.setValue(this.data.attributes.email);
    this.formMember.controls.celular.setValue(this.data.attributes.cellphone);
    this.formMember.controls.idRol.setValue(this.data.attributes.role?.data?.id);
  }

  getUserCompanies () {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[users_permissions_users]=${this.data.id}`)
    .subscribe((res: any) => {
      this.store.dispatch(OcultarSpinner());
      let companies = res.data.map( obj => obj.id )
      this.fillDataUser(companies);
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
      if(error?.error?.error?.message){
        this.openSnackBar(error?.error?.error?.message, 15000, 'outline', 'error');
      }else{
        this._snackBar.open(
          'Ocurrió un error al guardar el usuario',
          'OK',
          { duration: 5000 }
        )
      }
    })
  }

  getInitialData () {
    this.store.dispatch(MostrarSpinner());
    zip(
      this.coalService.getService('users-permissions/roles'),
      this.coalService.getService(`ope-empresas?filters[users_permissions_users]=${this.user.id}`)
    ).subscribe(
      (res: any) => {
        this.store.dispatch(OcultarSpinner());
        this.lstRoles = res[0].roles;
        this.lstEmpresas = res[1].data;
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
        this._snackBar.open(
          'Ocurrió un error al guardar el usuario',
          'OK',
          { duration: 5000 }
        )
      }
    )
  }
  
  addMember () {
    this.formMember.markAllAsTouched();
    this.formMember.updateValueAndValidity();

    if(!this.formMember.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea guardar este registro?'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result) {
        let params = {
          data: {
            email: this.formMember.value.email,
            password: this.formMember.value.password,
            name: this.formMember.value.nombre,
            cellphone: this.formMember.value.celular,
            ope_empresas: this.formMember.value.idEmpresas,
            role: this.formMember.value.idRol
          }
        }

        this.store.dispatch(MostrarSpinner());
        this.coalService.postService('ope-empresas/member', params)
        .subscribe((res: any) => {
          this.store.dispatch(OcultarSpinner());
          this.close(1);
        }, (error: any) => {

          this.store.dispatch(OcultarSpinner());
         
          if(error?.error?.error?.message){
            this.openSnackBar(error?.error?.error?.message, 15000, 'outline', 'error');
          }else{
            this._snackBar.open(
              'Ocurrió un error al guardar el usuario',
              'OK',
              { duration: 5000 }
            )
          }
        });
      }
    });
  }

  modifyMember () {
    this.formMember.markAllAsTouched();
    this.formMember.updateValueAndValidity();

    if(!this.formMember.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea modificar este registro?'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result) {
        let params = {
          data: {
            email: this.formMember.value.email,
            password: this.formMember.value.password,
            name: this.formMember.value.nombre,
            cellphone: this.formMember.value.celular,
            ope_empresas: this.formMember.value.idEmpresas,
            role: this.formMember.value.idRol
          }
        }

        this.store.dispatch(MostrarSpinner());
        this.coalService.putService(`ope-empresas/member/${this.data.id}`, params)
        .subscribe((res: any) => {
          this.store.dispatch(OcultarSpinner());
          this.close(1);
        }, (error: any) => {
          this.store.dispatch(OcultarSpinner());
          this._snackBar.open(
            'Ocurrió un error al guardar el usuario',
            'OK',
            { duration: 5000 }
          )
        })
      }
    })
  }

  close(status) {
    this.dialogRef.close({
      success: status
    });
  }

  openSnackBar(
    message: string,
    duration: number = 5000,
    appearance: 'fill' | 'outline' | 'soft' = 'fill',
    type: 'info' | 'success' | 'error' = 'info'
  ): void {
    const config: MatSnackBarConfig = {
      duration: duration,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: [`snackbar-type-${appearance}-${type}`],
    };
    this._snackBar.open(message, 'Ok', config);
  }
}
